import React from 'react'
import GoogleAutoComplete from 'react-google-autocomplete'
const GOOGLE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_API_KEY

const AutoComplete = props => {
  return (
    <GoogleAutoComplete
      apiKey={GOOGLE_API_KEY}
      options={{
        componentRestrictions: {
          country: 'us'
        },
        types: []
      }}
      {...props}
    />
  )
}

export default AutoComplete
